import { useApp } from "../context/AppContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { SYLLAPLUS_LOGO_B64 } from "../constants";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { handleResetPassword, getPasswordStrength, strengthColors, strengthWidths } = useApp();

  const [newPassword, setNewPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!newPassword.trim()) { setMessage("Please enter a new password."); return; }
    setLoading(true);
    setMessage("");
    const result = await handleResetPassword(token, newPassword);
    setMessage(result.message);
    setSuccess(result.success);
    setLoading(false);
  };

  if (!token) {
    return (
      <div style={{ maxWidth: "400px", margin: "80px auto", padding: "0 20px", fontFamily: "sans-serif", textAlign: "center" }}>
        <p style={{ fontSize: "14px", color: "#ef4444" }}>This reset link is missing a token. Please request a new one from the login page.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "400px", margin: "80px auto", padding: "0 20px", fontFamily: "sans-serif" }}>
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
          <img src={`data:image/png;base64,${SYLLAPLUS_LOGO_B64}`} alt="SyllaPlus" style={{ width: "32px", height: "32px" }} />
          <span style={{ fontSize: "22px", fontWeight: "500", color: "#1C2B3A" }}>SyllaPlus</span>
        </div>
        <p style={{ fontSize: "14px", color: "#6B7280", margin: 0 }}>Choose a new password</p>
      </div>
      <div style={{ background: "white", border: "0.5px solid #E5E7EB", borderRadius: "12px", padding: "24px" }}>
        {success ? (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: "14px", color: "#22c55e", marginBottom: "16px" }}>{message}</p>
            <button onClick={() => navigate("/login")}
              style={{ padding: "11px 24px", background: "#1C2B3A", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", cursor: "pointer", fontWeight: "500" }}>
              Go to Login
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <div>
              <input type="password" placeholder="New password" value={newPassword}
                onChange={e => { setNewPassword(e.target.value); setPasswordStrength(getPasswordStrength(e.target.value)); }}
                onKeyDown={e => e.key === "Enter" && submit()}
                style={{ width: "100%", padding: "10px 14px", borderRadius: "8px", border: "0.5px solid #E5E7EB", fontSize: "14px", outline: "none", background: "#F9FAFB", boxSizing: "border-box" }} />
              {passwordStrength && (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "8px" }}>
                  <div style={{ flex: 1, height: "4px", background: "#E5E7EB", borderRadius: "2px", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: strengthWidths[passwordStrength], background: strengthColors[passwordStrength], borderRadius: "2px", transition: "all 0.3s" }} />
                  </div>
                  <span style={{ fontSize: "12px", color: strengthColors[passwordStrength], minWidth: "36px" }}>{passwordStrength.charAt(0).toUpperCase() + passwordStrength.slice(1)}</span>
                </div>
              )}
            </div>
            {message && <p style={{ fontSize: "13px", color: "#ef4444", margin: 0 }}>{message}</p>}
            <button onClick={submit} disabled={loading}
              style={{ padding: "11px", background: loading ? "#9CA3AF" : "#1C2B3A", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", cursor: loading ? "default" : "pointer", fontWeight: "500" }}>
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}